import { IconButton, IconButtonProps } from "@material-ui/core";
import { AccountCircle as AccountIcon } from "@material-ui/icons";

export type AccountButtonProps = IconButtonProps;

const AccountButton = ({ ...p }: AccountButtonProps) => {
  return (
    <IconButton aria-label="Account" color="inherit" {...p}>
      <AccountIcon />
    </IconButton>
  );
};

export default AccountButton;
